'use client';

import foldarrow from '@/assets/images/convention/foldarrow.svg';
import ANKLELENGTH from '@/assets/images/convention/sizechart/ANKLELENGTH.svg';
import CathedralTrain from '@/assets/images/convention/sizechart/CathedralTrain.svg';
import ChapelTrain from '@/assets/images/convention/sizechart/ChapelTrain.svg';
import CourtTrain from '@/assets/images/convention/sizechart/CourtTrain.svg';
import FLOORLENGTH from '@/assets/images/convention/sizechart/FLOORLENGTH.svg';
import KNEELENGTH from '@/assets/images/convention/sizechart/KNEELENGTH.svg';
import MINI from '@/assets/images/convention/sizechart/MINI.svg';
import RoyalTrain from '@/assets/images/convention/sizechart/RoyalTrain.svg';
import SweepTrain from '@/assets/images/convention/sizechart/SweepTrain.svg';
import TEALENGTH from '@/assets/images/convention/sizechart/TEALENGTH.svg';
import jdAnkleLength from '@/assets/images/convention/sizechart/jd-AnkleLength.svg';
import jdFloorLength from '@/assets/images/convention/sizechart/jd-FloorLength.svg';
import jdKneeLength from '@/assets/images/convention/sizechart/jd-KneeLength.svg';
import jdMini from '@/assets/images/convention/sizechart/jd-Mini.svg';
import jdTeaLength from '@/assets/images/convention/sizechart/jd-TeaLength.svg';
import { websiteEnv } from '@/constants/website-env';
import useIsMobile from '@/hooks/use-is-mobile';
import clsx from 'clsx';
import Image from 'next/image';
import { useCallback, useState } from 'react';
import MeasuringGuide from './measuring-guide';
import classes from './sizeChart.module.css';

export const SizeChart = () => {
  const imgarry = {
    MINI: MINI,
    KNEELENGTH: KNEELENGTH,
    TEALENGTH: TEALENGTH,
    ANKLELENGTH: ANKLELENGTH,
    FLOORLENGTH: FLOORLENGTH,
    SweepTrain: SweepTrain,
    CourtTrain: CourtTrain,
    ChapelTrain: ChapelTrain,
    CathedralTrain: CathedralTrain,
    RoyalTrain: RoyalTrain,
    'jd-Mini': jdMini,
    'jd-KneeLength': jdKneeLength,
    'jd-TeaLength': jdTeaLength,
    'jd-AnkleLength': jdAnkleLength,
    'jd-FloorLength': jdFloorLength,
  };

  const isMobile = useIsMobile();
  const [showMeasuringGuid, setShowMeasuringGuid] = useState(false);
  const [MeasuringSize, setMeasuringSize] = useState(true);

  const changeMeasuringGuide = useCallback(() => {
    setShowMeasuringGuid(!showMeasuringGuid);
  }, [showMeasuringGuid]);
  const changeMeasuringSize = useCallback(() => {
    setMeasuringSize(!MeasuringSize);
  }, [MeasuringSize]);
  const SizeChart = [
    {
      title: 'Adult Dresses',
      children: {
        title: 'Adult Dresses',
        data: [
          {
            title: 'Adult Dresses',
            data: [
              ['us size', 'uk size', 'au size', 'eu size', 'it size', 'bust', 'waist', 'hip', 'hollow to hem'],
              ['US0', 'UK4', 'AU4', 'EU32', 'IT36', '32"', '25½"', '35½"', '58"'],
              ['US2', 'UK6', 'AU6', 'EU34', 'IT38', '33"', '26½"', '36½"', '58"'],
              ['US4', 'UK8', 'AU8', 'EU36', 'IT40', '34"', '27½"', '37½"', '59"'],
              ['US6', 'UK10', 'AU10', 'EU38', 'IT42', '35"', '28½"', '38½"', '59"'],
              ['US8', 'UK12', 'AU12', 'EU40', 'IT44', '36"', '29½"', '39½"', '60"'],
              ['US10', 'UK14', 'AU14', 'EU42', 'IT46', '37½"', '31"', '41"', '60"'],
              ['US12', 'UK16', 'AU16', 'EU44', 'IT48', '39"', '32½"', '42½"', '61"'],
              ['US14', 'UK18', 'AU18', 'EU46', 'IT50', '41"', '34¾"', '44½"', '61"'],
              ['US16', 'UK20', 'AU20', 'EU48', 'IT52', '43¼"', '37¼"', '46¾"', '61"'],
              ['US18', 'UK22', 'AU22', 'EU50', 'IT54', '45½"', '39¾"', '49"', '61"'],
              ['US20', 'UK24', 'AU24', 'EU52', 'IT56', '47¾"', '42¼"', '51½"', '61"'],
              ['US22', 'UK26', 'AU26', 'EU54', 'IT58', '50"', '44¾"', '53½"', '61"'],
              ['US24', 'UK28', 'AU28', 'EU56', 'IT60', '53"', '48"', '56½"', '61"'],
              ['US26', 'UK30', 'AU30', 'EU58', 'IT62', '56"', '51¼"', '59¼"', '61"'],
              ['US28', 'UK32', 'AU32', 'EU60', 'IT64', '59"', '54½"', '62½"', '61"'],
              ['US30', 'UK34', 'AU34', 'EU62', 'IT66', '63"', '58¾"', '66½"', '61"'],
            ],
          },
          {
            title: 'Dress Length',
            data: [
              [
                'size',
                'uk size',
                'au size',
                'eu size',
                'it size',
                'Mini',
                'Knee Length',
                'Tea Length',
                'Ankle Length',
                'Floor Length',
              ],
              [
                'Model',
                'Model',
                'Model',
                'Model',
                'Model',
                'MINI.svg',
                'KNEELENGTH.svg',
                'TEALENGTH.svg',
                'ANKLELENGTH.svg',
                'FLOORLENGTH.svg',
              ],
              ['US0', 'UK4', 'AU4', 'EU32', 'IT36', '33½"', '38"', '45½"', '53"', '58"'],
              ['US2', 'UK6', 'AU6', 'EU34', 'IT38', '33½"', '38"', '45½"', '53"', '58"'],
              ['US4', 'UK8', 'AU8', 'EU36', 'IT40', '33½"', '38"', '46½"', '53½"', '59"'],
              ['US6', 'UK10', 'AU10', 'EU38', 'IT42', '34"', '38"', '46½"', '53½"', '59"'],
              ['US8', 'UK12', 'AU12', 'EU40', 'IT44', '34"', '38½"', '47"', '54"', '60"'],
              ['US10', 'UK14', 'AU14', 'EU42', 'IT46', '34"', '38½"', '47"', '54"', '60"'],
              ['US12', 'UK16', 'AU16', 'EU44', 'IT48', '34"', '38½"', '48"', '55"', '61"'],
              ['US14', 'UK18', 'AU18', 'EU46', 'IT50', '35"', '38½"', '48½"', '55"', '61"'],
              ['US16', 'UK20', 'AU20', 'EU48', 'IT52', '35"', '39"', '48½"', '56"', '61"'],
              ['US18', 'UK22', 'AU22', 'EU50', 'IT54', '35"', '39"', '48½"', '56"', '61"'],
              ['US20', 'UK24', 'AU24', 'EU52', 'IT56', '35"', '39"', '48½"', '56"', '61"'],
              ['US22', 'UK26', 'AU26', 'EU54', 'IT58', '36"', '40"', '48½', '56"', '61"'],
              ['US24', 'UK28', 'AU28', 'EU56', 'IT60', '36', '40"', '48½"', '56"', '61"'],
              ['US26', 'UK30', 'AU30', 'EU58', 'IT62', '36"', '40"', '48½"', '56"', '61"'],
              ['US28', 'UK32', 'AU32', 'EU60', 'IT64', '36"', '40"', '48½"', '56"', '61"'],
              ['US30', 'UK34', 'AU34', 'EU62', 'IT66', '36"', '40"', '48½', '56"', '61"'],
            ],
          },
          {
            title: 'Train Length',
            istransition: !!isMobile,
            data: [
              ['Train', 'Sweep Train', 'Court Train', 'Chapel Train', 'Cathedral Train', 'Royal Train'],
              ['Model', 'SweepTrain.svg', 'CourtTrain.svg', 'ChapelTrain.svg', 'CathedralTrain.svg', 'RoyalTrain.svg'],
              ['Length', '12"', '18"', '24"', '32"', '48"'],
            ],
          },
        ],
      },
    },
    {
      title: 'Junior Bridesmaid Dresses',
      children: {
        title: 'Junior Bridesmaid Dresses',
        data: [
          {
            title: 'Junior Dresses',
            data: [
              ['Size', 'UK Size', 'AU Size', 'EU Size', 'Bust', 'Waist', 'Hips'],
              ['J6', 'J6', 'J6', 'J6', '26½"', '22"', '28½"'],
              ['J8', 'J8', 'J8', 'J8', '27½"', '23"', '29½"'],
              ['J10', 'J10', 'J10', 'J10', '28½"', '24"', '30½"'],
              ['J12', 'J12', 'J12', 'J12', '30"', '25"', '32"'],
              ['J14', 'J14', 'J14', 'J14', '31½"', '26"', '33½"'],
              ['J16', 'J16', 'J16', 'J16', '33"', '27"', '35"'],
              ['J18', 'J18', 'J18', 'J18', '34½"', '28"', '36½"'],
            ],
          },
          {
            title: 'Junior Dresses Length',
            data: [
              [
                'Size',
                'UK Size',
                'AU Size',
                'EU Size',
                'Mini',
                'Knee Length',
                'Tea Length',
                'Ankle Length',
                'Floor Length',
              ],
              [
                'Model',
                'Model',
                'Model',
                'Model',
                'jd-Mini.svg',
                'jd-KneeLength.svg',
                'jd-TeaLength.svg',
                'jd-AnkleLength.svg',
                'jd-FloorLength.svg',
              ],
              ['J6', 'J6', 'J6', 'J6', '29"', '33"', '37"', '42½"', '46"'],
              ['J8', 'J8', 'J8', 'J8', '30"', '34"', '39"', '44½"', '48"'],
              ['J10', 'J10', 'J10', 'J10', '31"', '36"', '41"', '46½"', '50"'],
              ['J12', 'J12', 'J12', 'J12', '32"', '38"', '43"', '48"', '52"'],
              ['J14', 'J14', 'J14', 'J14', '33"', '39"', '44"', '49"', '53"'],
              ['J16', 'J16', 'J16', 'J16', '34"', '40"', '45"', '50"', '54"'],
            ],
          },
        ],
      },
    },
    {
      title: 'Adult Satin Robes',
      children: {
        title: 'Adult Satin Robes',
        data: [
          {
            title: 'AW Satin Short Robes',
            data: [
              ['Size', 'US', 'Robe Length', 'Bust', 'Sleeve Length'],
              ['XS', '0-2', '35½"', '42½"', '11"'],
              ['S', '4-6', '36¼"', '44⅞"', '11¼"'],
              ['M', '8-10', '37"', '47¼"', '11½"'],
              ['L', '12-14', '37⅘"', '50"', '11½"'],
              ['XL', '16-18', '39"', '53½"', '11⅝"'],
              ['XXL', '20-22', '39"', '57¾"', '11¾"'],
            ],
          },
          {
            title: 'AW Satin Short Robes with Lace',
            data: [
              ['Size', 'US', 'Robe Length', 'Bust', 'Sleeve Length'],
              ['S', '4-6', '37¼"', '50¾"', '16"'],
              ['M', '8-10', '37¾"', '53⅛"', '16⅛"'],
              ['L', '12-14', '38⅜"', '55½"', '16⅜"'],
              ['XL', '16-18', '39"', '57⅞"', '16½"'],
            ],
          },
          {
            title: 'AW Satin Long Robes',
            data: [
              ['Size', 'US', 'Robe Length', 'Bust', 'Sleeve Length'],
              ['S', '2-4', '46"', '44⅞"', '12⅝"'],
              ['M', '4-6', '46⅝"', '47¼"', '12¾"'],
              ['L', '8-10', '47¼"', '49⅝"', '13"'],
              ['XL', '12-14', '47⅜"', '52"', '13¼"'],
            ],
          },
        ],
      },
    },
    {
      title: 'Children Satin Robes',
      children: {
        title: 'Children Satin Robes',
        data: [
          {
            title: 'Children Satin Robes',
            istransition: !!isMobile,
            data: [
              ['Size', 'Age Reference', 'Robe Length', 'Bust', 'Shoulder', 'Sleeve Length'],
              ['S', '2-3', '21¾"', '27½"', '11"', '7⅞"'],
              ['M', '4-5', '24⅜"', '30¾"', '12"', '8⅛"'],
              ['L', '6-8', '27½"', '34⅝"', '13"', '8¼"'],
              ['XL', '10-12', '30⅛"', '38⅝"', '14"', '8½"'],
            ],
          },
        ],
      },
    },
    {
      title: 'Pajamas Set',
      children: {
        title: 'Pajamas Set',
        data: [
          {
            title: 'Women`s Satin Pajamas Sets Size Chart',
            istransition: !!isMobile,
            data: [
              ['size', 'us', 'Sleeve Length', 'Full Bust', 'Top length', 'Shoulder', 'Waist', 'Hip', 'Pants Length'],
              ['S', '4-6', '8.5"', '40.0"', '26.0"', '15.0"', '27.5"', '41.0"', '38.5"'],
              ['M', '8-10', '8.6"', '43.0"', '27.0"', '16.5"', '29.6"', '44.0"', '39.4"'],
              ['L', '12-14', '8.8"', '45.9"', '28.0"', '17.3"', '32.5"', '47.0"', '40.5"'],
              ['XL', '16-18', '9.0"', '50.0"', '29.0"', '18.1"', '35.5"', '51.0"', '41.5"'],
            ],
          },
          {
            title: 'Men`s Satin Pajamas Sets Size Chart',
            istransition: !!isMobile,
            data: [
              ['size', 'us', 'Sleeve Length', 'Full Bust', 'Top length', 'Shoulder', 'Waist', 'Hip', 'Pants Length'],
              ['M', '8-10', '9.8"', '46.0"', '29.5"', '18.5"', '30.0"', '47.2"', '40.5"'],
              ['L', '12-14', '10.1"', '50.0"', '30.7"', '19.6"', '33.0"', '51.1"', '41.5"'],
              ['XL', '16-18', '10.4"', '54.0"', '31.9"', '20.8"', '36.0"', '55.1"', '42.5"'],
            ],
          },
          {
            title: 'Women`s Pajamas Set',
            istransition: !!isMobile,
            data: [
              ['size', 'us', 'Sleeve Length', 'Full Bust', 'Top Length', 'Waist', 'Pants Length', 'Shoulder'],
              ['S', '4-6', '22.8"', '36.2"', '25.2"', '13.4"', '39.8"', '15.7"'],
              ['M', '8-10', '23.2"', '39.4"', '26.0"', '15.0"', '40.6"', '16.1"'],
              ['L', '12-14', '23.6"', '42.5"', '26.8"', '15.7"', '41.3"', '16.7"'],
            ],
          },
          {
            title: 'Men`s Pajamas Set',
            istransition: !!isMobile,
            data: [
              ['size', 'us', 'Sleeve Length', 'Full Bust', 'Top Length', 'Waist', 'Pants Length', 'Shoulder'],
              ['M', '8-10', '25.2"', '42.5"', '28.7"', '15.7"', '42.1"', '18.1"'],
              ['L', '12-14', '25.6"', '46.5"', '29.9"', '17.3"', '43.1"', '18.9"'],
              ['XL', '16-18', '26.0"', '50.4"', '30.3"', '18.9"', '44.1"', '19.6"'],
            ],
          },
        ],
      },
    },
  ];

  if (isMobile) {
    const isTransitionData = SizeChart.filter(
      item => item.title == 'Pajamas Set' || item.title == 'Children Satin Robes' || item.title == 'Adult Dresses',
    ); // .children.data;

    isTransitionData.map(tableitem => {
      tableitem.children.data.map(item => {
        if (item.istransition) {
          item.data =
            item.data.length > 0
              ? item.data[0].map((r, t) => {
                  return item.data.map((h, i) => {
                    return h[t];
                  });
                })
              : [];
        }
      });
    });
  }

  const [sizeTypeArrow, setsizeTypeArrow] = useState(
    SizeChart.map(() => {
      return {
        arrow: false,
      };
    }),
  );
  const changeSizeTypeArrow = useCallback((index, s) => {
    const state = sizeTypeArrow;

    state[index].arrow = s;
    const data = Object.assign({}, sizeTypeArrow, {
      sizeTypeArrow: state,
    });

    setsizeTypeArrow(data);
  });

  return (
    <div className='mx-auto max-w-site pb-20 pt-[25px] lg_pb-[128px] lg_pt-[60px]'>
      <h1 className='text-center font-Shango text-[34px] leading-10 lg_text-[46px] lg_leading-[56px]'>
        {websiteEnv.isUnitedKingdom ? 'SIZE GUIDE' : 'SIZE CHART'}
      </h1>
      <h6 className='mt-2 px-[18px] text-center text-[17px] leading-6 lg_mt-2.5'>
        View our sizing guidelines below to find your perfect fit. Those size guides also can be found on the individual
        product pages.
      </h6>
      <div className={classes.measuringguide}>
        <div className={classes.items}>
          <div
            className={clsx(
              'flex  cursor-pointer items-center gap-x-[5px] border-b-1 border-solid py-3',
              showMeasuringGuid ? 'border-transparent' : 'border-E7DED5',
            )}
            onClick={changeMeasuringGuide}
          >
            <div
              className={clsx(
                'relative h-9 w-9',
                'before_absolute before_left-1/2 before_top-1/2 before_h-0.5 before_w-4 before_-translate-x-1/2 before_-translate-y-1/2 before_bg-#403732 before_content-[""]',
                'after_absolute after_left-1/2 after_top-1/2 after_h-4 after_w-0.5 after_-translate-x-1/2 after_-translate-y-1/2 after_bg-#403732 after_content-[""]',
                'after_duration-[300ms] after_transition-transform',
                showMeasuringGuid ? 'after_rotate-90' : '',
              )}
            />
            <h2 className='font-Shango text-[26px] leading-8'>MEASURING GUIDE</h2>
          </div>

          <MeasuringGuide className={clsx(!showMeasuringGuid && 'hidden')} />
        </div>
        <div className={classes.sizecharts}>
          <div
            className={clsx(
              'flex  cursor-pointer items-center gap-x-[5px] border-b-1 border-solid py-3',
              MeasuringSize ? 'border-transparent' : 'border-E7DED5',
            )}
            onClick={changeMeasuringSize}
          >
            <div
              className={clsx(
                'relative h-9 w-9',
                'before_absolute before_left-1/2 before_top-1/2 before_h-0.5 before_w-4 before_-translate-x-1/2 before_-translate-y-1/2 before_bg-#403732 before_content-[""]',
                'after_absolute after_left-1/2 after_top-1/2 after_h-4 after_w-0.5 after_-translate-x-1/2 after_-translate-y-1/2 after_bg-#403732 after_content-[""]',
                'after_duration-[300ms] after_transition-transform',
                MeasuringSize ? 'after_rotate-90' : '',
              )}
            />
            <h2 className='font-Shango text-[26px] leading-8'>
              {websiteEnv.isUnitedKingdom ? 'SIZE GUIDE' : 'SIZE CHART'}
            </h2>
          </div>
          <div
            className={clsx(
              classes.measuringcon,
              classes.measuringsizecon,
              MeasuringSize ? classes.measuringsizeshow : null,
              'px-[15px] lg_pl-10',
            )}
          >
            {SizeChart.map((item, index) => (
              <div
                className={classes.chart}
                key={index}
              >
                <div
                  className={classes.charttitle}
                  onClick={() => changeSizeTypeArrow(index, !sizeTypeArrow[index].arrow)}
                >
                  <Image
                    className={[classes.arrow, sizeTypeArrow[index].arrow ? classes.arrowimgshow : null].join(' ')}
                    src={foldarrow}
                    alt=''
                  />
                  <p className={classes.charttitletext}>{item.title}</p>
                </div>
                <div
                  className={[classes.charttablecon, sizeTypeArrow[index].arrow ? classes.charttableshow : null].join(
                    ' ',
                  )}
                >
                  {item.children.data.map((tb, tbindex) => (
                    <div
                      className={classes.charttable}
                      key={tbindex}
                    >
                      <p className={classes.tabletitle}>{tb.title}</p>
                      <table className={[classes.sizetable, tb.istransition ? classes.istransition : null].join(' ')}>
                        <tbody>
                          {tb.data.map((tr, trindex) => (
                            <tr
                              key={trindex}
                              className={classes.sizetr}
                            >
                              {tr.map((td, tdindex) => (
                                <td
                                  className={classes.sizetd}
                                  key={tdindex}
                                >
                                  {td.indexOf('.svg') > -1 ? (
                                    <Image
                                      className={classes.moduleimg}
                                      src={imgarry[td.split('.')[0]]}
                                      alt=''
                                    />
                                  ) : (
                                    td
                                  )}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeChart;
